import { useDialogStore } from '@/stores/dialog';
export async function showConfirm(message) {
  const action = /^(delete|remove|discard|restore|unpublish)/i.exec(String(message).trim())?.[1]?.toLowerCase();
  const label = action ? action[0].toUpperCase() + action.slice(1) : 'Continue';
  const result = await useDialogStore().confirm({ title: action ? `${label} confirmation` : 'Please confirm', message: String(message), buttons: 'ok-cancel', variant: ['delete', 'remove'].includes(action) ? 'error' : 'info', confirmLabel: label });
  return result === 'ok';
}
export function showMessage(message) {
  return useDialogStore().confirm({ title: /fail|error|unavailable/i.test(String(message)) ? 'Something went wrong' : 'Please note', message: String(message), buttons: 'ok', variant: /fail|error/i.test(String(message)) ? 'error' : 'info', confirmLabel: 'Got it' });
}
